(function ($) {
  DJ.addBehavior('resourcesSlider', '.resources-slider', {
    attach: function () {
      const resourcesSliderHolder = this;
      const slider = resourcesSliderHolder.querySelector('.resources-slider__slider');
      const $slider = $(slider);
      let checkedValues = [];
      const itemsForSliderHolder = resourcesSliderHolder.querySelector('.resources-slider__slider-items');

      if (!slider) {
        return false;
      }

      /**
       * Set equal height for elements.
       * @param elements
       *    elements selector.
       */
      const setEqualHeight = (elements) => {
        if (!elements) {
          return false;
        }

        let maxHeight = -1;
        const elementsArr = Array.prototype.slice.call(elements);

        elementsArr.forEach((e) => {
          maxHeight = Math.max(maxHeight, e.offsetHeight);
        });

        elementsArr.forEach((e) => {
          e.style.height = `${maxHeight}px`;
        });

        return true;
      };

      /**
       * Slider options.
       */
      const sliderOptions = {
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        variableWidth: true,
        dots: true,
        arrows: true,
        useCSS: false,
        prevArrow: `<button type="button" class="slick-prev">
                    </button>`,
        nextArrow: `<button type="button" class="slick-next">
                    </button>`,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: false
            }
          }
        ]
      };

      /**
       * Slider init function with setting the equal height to the needed elements.
       */
      const sliderInit = () => {
        const resourcesItem = slider.querySelectorAll('.resources-item');
        const resourcesActivities = slider.querySelectorAll('.resources-item__activities');
        const resourcesAnalysis = slider.querySelectorAll('.resources-item__analysis');
        const resourcesAttachments = slider.querySelectorAll('.resources-item__attachments');

        setEqualHeight(resourcesActivities);
        setEqualHeight(resourcesAnalysis);
        setEqualHeight(resourcesAttachments);
        setEqualHeight(resourcesItem);
        $slider.slick(sliderOptions);
        DJ.attachBehavior('brioTooltip');
      };

      sliderInit();

      const filtersCheckboxes = Array.prototype.slice.call(
        resourcesSliderHolder.querySelectorAll('.resources-filters__checkbox-input')
      );

      if (filtersCheckboxes) {
        filtersCheckboxes.forEach((filterCheckbox) => {
          filterCheckbox.addEventListener('change', (e) => {
            const stayClass = 'resources-item--stay';
            $slider.slick('unslick');
            slider.innerHTML = itemsForSliderHolder.innerHTML;

            if (e.target.checked) {
              checkedValues.push(e.target.value);
            } else {
              checkedValues = checkedValues.filter((arrItem) => arrItem !== e.target.value);
            }

            if (!checkedValues.length) {
              sliderInit();
              return false;
            }

            checkedValues.forEach((checkedValue) => {
              const slidesToStay = slider.querySelectorAll(`.resources-item--${checkedValue}`);

              Array.prototype.slice.call(slidesToStay).forEach((slideToStay) => {
                if (!slideToStay.classList.contains(stayClass)) {
                  slideToStay.classList.add(stayClass);
                }
              });
            });

            const slidesToRemove = slider.querySelectorAll('.resources-slider__slider-item');

            Array.prototype.slice.call(slidesToRemove).forEach((slideToRemove) => {
              const slideInner = slideToRemove.querySelector('.resources-item');
              if (slideInner && !slideInner.classList.contains(stayClass)
                && slideToRemove.parentNode) {
                slideToRemove.parentNode.removeChild(slideToRemove);
              }
            });

            sliderInit();

            return true;
          });
        });
      }

      $slider.on('afterChange', function () {
        DJ.attachBehavior('brioTooltip');
      });

      return true;
    }
  });
})(jQuery);
